import React from 'react';

import { forms } from './data';

interface FormListProps {
  onSelect: (id: string) => void;
}

export default function FormList({ onSelect }: FormListProps) {
  const handleClick = (idx: number) => () => {
    onSelect(String(idx));
  };

  return (
    <div className="m-16 list">
      <table>
        <thead>
          <tr>
            <th>Form</th>
            <th aria-label="Blank" />
          </tr>
        </thead>
        <tbody>
          {
            forms.map((form, idx) => (
              <tr key={form.id} onClick={handleClick(idx)} role="button" className="clickable">
                <td>
                  <div className="list-label">{form.title}</div>
                  <div className="list-description">{form.description}</div>
                </td>
                <td />
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}
